import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Table } from 'material-ui';
import { FormattedMessage } from 'react-intl';
import { TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn } from 'material-ui/Table';
import { map } from 'lodash';
import { fetchApprovalRequests } from './actions';
import Loading from '../../components/Loading';
import PanelMessage from '../../components/panels/PanelMessage';
import pallet from '../../constants/colors';
import KTitle from '../../components/KJRN/KTitle';

const styles = {
  tag: {
    fontSize: 14,
    color: 'white',
    borderRadius: 24,
    padding: 6,
    textAlign: 'center',
    width: 80,
  },
  tableColumn: {
    whiteSpace: 'normal',
    width: 120,
  },
};

const ApprovalRequests = () => {
  const dispatch = useDispatch();

  const { approvalRequestsReducer } = useSelector(state => state);
  const {
    approvalRequests, error, hasError, loading,
  } = approvalRequestsReducer;

  useEffect(() => {
    dispatch(fetchApprovalRequests());
  }, [dispatch]);
  const getTag = (status) => {
    switch (status) {
      case 'Pending':
      case 'Expired':
        return (
          <div style={{ ...styles.tag, backgroundColor: pallet.grey }}>
            <FormattedMessage id="approval.status.Pending" />
          </div>);
      case 'Accepted':
        return (
          <div style={{ ...styles.tag, backgroundColor: pallet.successColor }}>
            <FormattedMessage id="approval.status.Accepted" />
          </div>);
      case 'Rejected':
        return (
          <div style={{ ...styles.tag, backgroundColor: pallet.errorColor }}>
            <FormattedMessage id="approval.status.Rejected" />
          </div>);
      case 'Canceled':
        return (
          <div style={{ ...styles.tag, backgroundColor: pallet.warningColor }}>
            <FormattedMessage id="approval.status.Canceled" />
          </div>);
      default: return null;
    }
  };
  return (
    <div style={{ maxWidth: 960, margin: 'auto' }}>
      <div style={{ margin: 16 }}>
        <KTitle containerStyle={{ maxWidth: 1400, margin: 'auto' }} key="hb" title={<FormattedMessage id="dash.title.approvals" />} />
      </div>
      {loading && <Loading height="70vh" />}
      {!loading && hasError && (
        <PanelMessage
          type="error"
          iconName="error"
          message={error && error.Message ? error.Message : <FormattedMessage id="approvals.error" />}
        />
      )}
      <Table selectable={false}>
        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
          <TableRow>
            <TableHeaderColumn styles={styles.tableColumn}>
              <FormattedMessage id="approval.type" />
            </TableHeaderColumn>
            <TableHeaderColumn styles={styles.tableColumn}>
              <FormattedMessage id="approval.date.from" />
            </TableHeaderColumn>
            <TableHeaderColumn styles={styles.tableColumn}>
              <FormattedMessage id="approval.date.to" />
            </TableHeaderColumn>
            <TableHeaderColumn styles={styles.tableColumn}>
              <FormattedMessage id="approval.status" />
            </TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody displayRowCheckbox={false}>
          {!loading && map(approvalRequests, ({
            EmployeeDetailApprovalRequestType,
            PeriodBegda,
            PeriodEndda,
            ApprovalRequestStatus,
          }) => (
            <TableRow>
              <TableRowColumn styles={styles.tableColumn}>
                <FormattedMessage id={`approval.type.${EmployeeDetailApprovalRequestType}`} />
              </TableRowColumn>
              <TableRowColumn styles={styles.tableColumn}>
                {PeriodBegda && moment(PeriodBegda).format('DD.MM.YYYY')}
              </TableRowColumn>
              <TableRowColumn styles={styles.tableColumn}>
                {PeriodEndda && moment(PeriodEndda).format('DD.MM.YYYY')}
              </TableRowColumn>
              <TableRowColumn styles={styles.tableColumn}>
                {getTag(ApprovalRequestStatus)}
              </TableRowColumn>
            </TableRow>
        ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default ApprovalRequests;



// WEBPACK FOOTER //
// ./src/sites/approvalRequests/ApprovalRequests.js